<template>
    <el-dialog title="Доп соглашение" :visible.sync="visibleModalModel" width="550px" :append-to-body="true" v-loading="isLoading">
        <AdditionalAgreementForm v-if="agreement" mode="create" @saved="onSaved" :agreement="agreement"  />
    </el-dialog>
</template>

<script>

import AdditionalAgreementForm from "./AdditionalAgreementForm";
export default {
    name: "ModalEdit",
    components: {AdditionalAgreementForm},
    props: ['visibleModal', 'dealId'],
    data: () => ({
        isLoading: false,
        agreement: null,
    }),
    mounted() {
        this.fetch();
    },
    computed: {
        visibleModalModel: {
            get () { return this.visibleModal },
            set (value) { this.$emit('update:visibleModal', value) },
        },
    },
    methods: {
        onSaved() {
            this.visibleModalModel = false;
            this.$emit('saved');
        },
        fetch() {
            this.isLoading = true;
            axios.get('/api/deals/' + this.dealId)
                .then(res => {
                    this.agreement = {
                        deal_id: this.dealId,
                    }
                    this.isLoading = false;
                })
        }
    }
}
</script>

<style scoped>

</style>
